export default "__VITE_ASSET__e83f0569__"